import { useEffect } from 'react';

import { useFilterParams } from 'modules/_common';

export const useGlobalSearchInputValue = () => {
  const { handleFilterChange } = useFilterParams();

  const setGlobalSearchValue = ({ inputValue }: { inputValue?: any }) => {
    if (!inputValue) {
      localStorage.removeItem('globalSearch');

      return;
    }

    const normalizedValue = String(inputValue).trim();

    localStorage.setItem('globalSearch', normalizedValue);

    return normalizedValue;
  };

  const getGlobalSearchValue = () => {
    const localStorageValue = localStorage.getItem('globalSearch');

    return localStorageValue;
  };

  useEffect(() => {
    if (getGlobalSearchValue()) {
      handleFilterChange('search', getGlobalSearchValue());
    }
  }, [getGlobalSearchValue()]);

  return { setGlobalSearchValue, getGlobalSearchValue };
};
